<template>
  <conditions-editor
    ref="conditions-editor"
    v-model="value"
    data-model-name="Campaign"
    data-model-attribute="goal_conditions"
    attribute-list-data-url="/goal/goal/attribute-list-data"
    :preview="false"
    :no-data-alert="false"
    :single-level="true"
    :condition-button-fixed="true"
    :show-all-time="allTime"
    :show-event-value-property="true"
  />
</template>

<script>
import ConditionsEditor from '@/common/components/ConditionsEditor'
import { cloneDeep } from 'lodash'
export default {
  name: 'GoalConversion',
  components: { ConditionsEditor },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    value: {
      get: function() {
        const conditions = cloneDeep(this.model.goal_conditions)
        const preparedConditions = {
          0: {
            operator: 'OR'
          },
          operator: 'OR'
        }

        Object.keys(conditions[0]).forEach(row => {
          preparedConditions[0][row] = conditions[0][row]

          if (
            conditions[0][row][4] &&
            conditions[0][row][4][0] === 'date' &&
            conditions[0][row][4][1] === 'between' &&
            conditions[0][row][4][2] &&
            typeof conditions[0][row][4][2] === 'string'
          ) {
            preparedConditions[0][row][4][2] = conditions[0][row][4][2].split(
              ' to '
            )
          }
        })

        return preparedConditions
      },
      set: function(newValue) {
        this.model.goal_conditions = newValue
      }
    },
    allTime() {
      return this.$store.state.app.project.all_time
    }
  }
}
</script>

<style scoped>
>>> .main-item {
  width: 220px !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/GoalConversion.vue